import { setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

export const useOpacity = (textBox: TextBox) => {
    const dispatch = useAppDispatch();
    function handleOpacityChange(value: number) {
        if (value < 0 || value > 100 || isNaN(value)) throw new Error(`Invalid opacity: ${value}`);
        dispatch(
            setSettings({
                id: textBox.id,
                opacity: value,
            }),
        );
    }
    return { handleOpacityChange };
};
